const generateProfileTabs = ({ profile, organization }) => {
  const { hasGridFeature, hasStoriesFeature } = organization || {};
  const { service, isManager, shouldHideAdvancedAnalytics } = profile || {};
  const isInstagramChannel = service === 'instagram';
  const isTiktokChannel = service === 'tiktok';

  const tabsList = ['queue', 'sentPosts', 'settings', 'drafts'];
  if (isInstagramChannel) {
    tabsList.push('pastReminders');
  }
  if (!shouldHideAdvancedAnalytics) {
    tabsList.push('overview');
  }
  if (isManager) {
    tabsList.push('awaitingApproval');
  }
  if (!isManager) {
    tabsList.push('pendingApproval');
  }
  if (hasGridFeature && isInstagramChannel) {
    tabsList.push('grid');
  }
  if (hasStoriesFeature && isInstagramChannel) {
    tabsList.push('stories');
  }
  if (isTiktokChannel) {
    tabsList.push('pendingTiktok');
  }

  return tabsList;
};

export default generateProfileTabs;
